class InlineDatePicker {
	constructor() {
		this.currentDate = new Date();
		this.selectedStart = null;
		this.selectedEnd = null;
		this.tempStart = null;
		this.tempEnd = null;

		// Set rightMonth to current month, leftMonth to previous month
		this.rightMonth = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
		this.leftMonth = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, 1);

		this.isSelectingRange = false;
		this.activeInput = null;

		this.init();
	}

	init() {
		this.renderCalendars();
		this.bindEvents();
	}

	bindEvents() {
		const startDateInput = document.getElementById('filter_start_date');
		const endDateInput = document.getElementById('filter_end_date');
		const overlay = document.getElementById('overlay');

		// Input click events
		startDateInput.addEventListener('click', () => this.showDatePicker('filter_start_date'));
		endDateInput.addEventListener('click', () => this.showDatePicker('filter_end_date'));

		// Calendar navigation
		document.getElementById('prevMonth').addEventListener('click', () => this.previousMonth());
		document.getElementById('nextMonth').addEventListener('click', () => this.nextMonth());

		// Preset buttons
		document.querySelectorAll('.preset-item').forEach(item => {
			item.addEventListener('click', (e) => this.handlePresetClick(e.target.dataset.preset));
		});

		// Dropdown actions
		document.getElementById('applyBtn').addEventListener('click', () => this.applyDateRange());
		document.getElementById('cancelBtn').addEventListener('click', () => this.hideDatePicker());

		// Overlay click to close
		overlay.addEventListener('click', () => this.hideDatePicker());

		// Form submission
		document.getElementById('submitBtn').addEventListener('click', (e) => this.handleSubmit(e));

		// Close dropdown on escape
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				this.hideDatePicker();
			}
		});
	}

	showDatePicker(inputType) {
		this.activeInput = inputType;
		const dropdown = document.getElementById('startDateDropdown');
		const overlay = document.getElementById('overlay');

		// Set temp values to current selected values
		this.tempStart = this.selectedStart ? new Date(this.selectedStart) : null;
		this.tempEnd = this.selectedEnd ? new Date(this.selectedEnd) : null;

		dropdown.classList.add('active');
		overlay.classList.add('active');

		// Add active class to the clicked input
		document.querySelectorAll('.date-input').forEach(input => input.classList.remove('active'));
		document.getElementById(inputType).classList.add('active');

		this.updateDropdownDisplay();
		this.renderCalendars();
	}

	hideDatePicker() {
		const dropdown = document.getElementById('startDateDropdown');
		const overlay = document.getElementById('overlay');

		dropdown.classList.remove('active');
		overlay.classList.remove('active');

		document.querySelectorAll('.date-input').forEach(input => input.classList.remove('active'));
		document.querySelectorAll('.preset-item').forEach(item => item.classList.remove('active'));

		this.activeInput = null;
		this.isSelectingRange = false;
	}

	handlePresetClick(preset) {
		// Remove active class from all presets
		document.querySelectorAll('.preset-item').forEach(item => item.classList.remove('active'));

		// Add active class to clicked preset
		event.target.classList.add('active');

		const today = new Date(this.currentDate);
		let start, end;

		switch (preset) {
			case 'today':
				start = end = new Date(today);
				break;
			case 'yesterday':
				start = end = new Date(today.getTime() - 24 * 60 * 60 * 1000);
				break;
			case 'thisWeek':
				start = new Date(today);
				start.setDate(today.getDate() - today.getDay() + 1);
				end = new Date(today);
				break;
			case 'last7Days':
				start = new Date(today.getTime() - 6 * 24 * 60 * 60 * 1000);
				end = new Date(today);
				break;
			case 'lastWeek':
				start = new Date(today);
				start.setDate(today.getDate() - today.getDay() - 6);
				end = new Date(start.getTime() + 6 * 24 * 60 * 60 * 1000);
				break;
			case 'monthToDate':
				start = new Date(today.getFullYear(), today.getMonth(), 1);
				end = new Date(today);
				break;
			case 'lastMonth':
				start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
				end = new Date(today.getFullYear(), today.getMonth(), 0);
				break;
			case 'yearToDate':
				start = new Date(today.getFullYear(), 0, 1);
				end = new Date(today);
				break;
			default:
				return;
		}

		this.tempStart = start;
		this.tempEnd = end;
		this.updateDropdownDisplay();
		this.renderCalendars();
		this.applyDateRange()
	}

	previousMonth() {
		this.leftMonth.setMonth(this.leftMonth.getMonth() - 1);
		this.rightMonth.setMonth(this.rightMonth.getMonth() - 1);
		this.renderCalendars();
	}

	nextMonth() {
		this.leftMonth.setMonth(this.leftMonth.getMonth() + 1);
		this.rightMonth.setMonth(this.rightMonth.getMonth() + 1);
		this.renderCalendars();
	}

	renderCalendars() {
		this.renderCalendar('leftCalendar', this.leftMonth);
		this.renderCalendar('rightCalendar', this.rightMonth);

		document.getElementById('leftMonthTitle').textContent =
			this.leftMonth.toLocaleString('default', { month: 'long', year: 'numeric' }).toUpperCase();
		document.getElementById('rightMonthTitle').textContent =
			this.rightMonth.toLocaleString('default', { month: 'long', year: 'numeric' }).toUpperCase();
	}

	renderCalendar(elementId, monthDate) {
		const calendar = document.getElementById(elementId);
		calendar.innerHTML = '';

		const year = monthDate.getFullYear();
		const month = monthDate.getMonth();
		const firstDay = new Date(year, month, 1);
		const startDate = new Date(firstDay);

		// Start from Monday
		startDate.setDate(startDate.getDate() - ((startDate.getDay() + 6) % 7));

		for (let i = 0; i < 42; i++) {
			const date = new Date(startDate);
			date.setDate(startDate.getDate() + i);

			const dayElement = document.createElement('div');
			dayElement.className = 'calendar-day';
			dayElement.textContent = date.getDate();

			if (date.getMonth() !== month) {
				dayElement.classList.add('other-month');
			}

			if (this.isSameDay(date, this.currentDate)) {
				dayElement.classList.add('today');
			}

			if (this.tempStart && this.tempEnd && this.isInDateRange(date, this.tempStart, this.tempEnd)) {
				if (this.isSameDay(date, this.tempStart) || this.isSameDay(date, this.tempEnd)) {
					dayElement.classList.add('selected');
				} else {
					dayElement.classList.add('in-range');
				}
			}

			dayElement.addEventListener('click', () => this.handleDateClick(date));
			calendar.appendChild(dayElement);
		}
	}

	handleDateClick(date) {
		if (!this.isSelectingRange) {
			this.tempStart = new Date(date);
			this.tempEnd = new Date(date);
			this.isSelectingRange = true;
		} else {
			if (date < this.tempStart) {
				this.tempEnd = this.tempStart;
				this.tempStart = new Date(date);
			} else {
				this.tempEnd = new Date(date);
			}
			this.isSelectingRange = false;
		}

		// Remove active class from all presets
		document.querySelectorAll('.preset-item').forEach(item => item.classList.remove('active'));

		this.updateDropdownDisplay();
		this.renderCalendars();
	}

	applyDateRange() {
		this.selectedStart = this.tempStart;
		this.selectedEnd = this.tempEnd;
		this.updateInputs();
		this.hideDatePicker();
	}

	updateInputs() {
		const formatDate = (date) => {
			if (!date) return '';
			return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
		};

		document.getElementById('filter_start_date').value = formatDate(this.selectedStart);
		document.getElementById('filter_end_date').value = formatDate(this.selectedEnd);

		// Enable/disable submit button
		const submitBtn = document.getElementById('submitBtn');
		submitBtn.disabled = !(this.selectedStart && this.selectedEnd);
	}

	updateDropdownDisplay() {
		const formatDate = (date) => {
			if (!date) return '--';
			return `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${date.getFullYear()}`;
		};

		document.getElementById('dropdownStartDate').textContent = formatDate(this.tempStart);
		document.getElementById('dropdownEndDate').textContent = formatDate(this.tempEnd);
	}

	isInDateRange(date, start, end) {
		if (!start || !end) return false;
		const dateOnly = new Date(date.getFullYear(), date.getMonth(), date.getDate());
		const startOnly = new Date(start.getFullYear(), start.getMonth(), start.getDate());
		const endOnly = new Date(end.getFullYear(), end.getMonth(), end.getDate());
		return dateOnly >= startOnly && dateOnly <= endOnly;
	}

	isSameDay(date1, date2) {
		if (!date1 || !date2) return false;
		return date1.getDate() === date2.getDate() &&
			date1.getMonth() === date2.getMonth() &&
			date1.getFullYear() === date2.getFullYear();
	}

	handleSubmit(e) {
		e.preventDefault();

		if (!this.selectedStart || !this.selectedEnd) {
			return;
		}

		// Format dates as YYYY-MM-DD for URL parameters
		const formatDateForURL = (date) => {
			return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
		};

		const startDate = formatDateForURL(this.selectedStart);
		const endDate = formatDateForURL(this.selectedEnd);

		// Get current URL and update parameters
		const url = new URL(window.location);
		url.searchParams.set('start_date', startDate);
		url.searchParams.set('end_date', endDate);
		url.searchParams.delete('page'); // Reset to first page on new filter

		// Navigate to the new URL
		window.location.href = url.toString();
	}

}

// Initialize the date picker when the page loads
document.addEventListener('DOMContentLoaded', () => {

	const datePickerWidget = document.querySelector('#date-picker-filter');
	const startDateInput = document.getElementById('filter_start_date');
	const endDateInput = document.getElementById('filter_end_date');

	if (startDateInput && endDateInput) {

		// Pre-fill inputs from URL parameters if available
		const urlParams = new URLSearchParams(window.location.search);
		const startDateParam = urlParams.get('start_date');
		const endDateParam = urlParams.get('end_date');
		if (startDateParam && endDateParam) {
			startDateInput.value = startDateParam;
			endDateInput.value = endDateParam;
		} else {
			// Default to current month if no params
			const today = new Date();
			const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

			startDateInput.value = `${lastMonth.getFullYear()}-${String(lastMonth.getMonth() + 1).padStart(2, '0')}-${String(lastMonth.getDate()).padStart(2, '0')}`;
			endDateInput.value = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
		}
	}

	if (datePickerWidget) {
		new InlineDatePicker();
	}
});